interface Props {
  link: string;
  site?: string;
}

export const queryStringSiteConverter = ({ link, site = 'market' }: Props) => {
  if (!link) {
    return link;
  }

  const trimLink = link.trim();
  const lowerLink = link.toLowerCase();

  if (
    !trimLink ||
    lowerLink.includes('site=market') ||
    lowerLink.includes('site=beauty') ||
    trimLink.includes('kurly://')
  ) {
    return trimLink;
  }

  if (site.toLowerCase() === 'beauty') {
    const specialCharacter = link.includes('?') ? '&' : '?';
    return `${trimLink}${specialCharacter}site=beauty`;
  }

  return link;
};
